import layout from './results-map-layout.json';

export const RESULT_MAP_LAYOUT = layout;
export const RESULT_MAP_NEIGHBORHOODS = layout.neighborhoods.map(({ neighborhood }) => neighborhood);
const RESULT_MAP_DISPLAY_NAMES: Readonly<Record<string, string>> = {
  'The Greens (Southeast)': 'Fairwood Greens (Southeast)*',
  'Candlewood Ridge': 'Candlewood Ridge*',
  Carriagewood: 'Carriage Wood',
  'Near Ridgewood': 'Near Ridgewood*',
};

export function resultMapDisplayName(neighborhood: string): string {
  return RESULT_MAP_DISPLAY_NAMES[neighborhood] ?? neighborhood;
}

export function resultScaleForZoom(zoom: number): number {
  const scale = 0.24 * (2 ** ((zoom - 12.5) / 1.5));
  return Math.round(Math.max(0.1, Math.min(1, scale)) * 1_000) / 1_000;
}
